import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=fa0a14ac&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/pei/parte-k.css?vue&type=style&index=0&id=fa0a14ac&prod&scoped=true&lang=css&external"
import style1 from "./Master.vue?vue&type=style&index=1&id=fa0a14ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0a14ac",
  null
  
)

export default component.exports